import { useContext } from "react";
import { DealerContext, DealerContextProps } from "./context";
import { useDealerContextController } from "./controller";

const DealerContextProvider: React.FC<{ children: any }> = ({ children }) => {
  return (
    <DealerContext.Provider value={{ ...useDealerContextController() }}>
      {children}
    </DealerContext.Provider>
  );
};

function useDealer(): DealerContextProps {
  const context = useContext(DealerContext);

  if (!context) {
    throw new Error("useDealer must be used within a DealerContextProvider.");
  }

  return context;
}

export { DealerContextProvider, useDealer };
